/* eslint-disable */
import { memo, forwardRef } from "react";

// preview/mail.tsx
export const MailIcon = memo(
  forwardRef(function MailIcon(
    { size = 18, color = "currentColor", title, className, ...rest },
    ref,
  ) {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden={title ? undefined : true}
        {...rest}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.83279 10.0986C8.33104 10.0986 7.83079 9.93287 7.41229 9.60137L4.04854 6.88937C3.80629 6.69437 3.76879 6.33962 3.96304 6.09812C4.15879 5.85737 4.51279 5.81912 4.75429 6.01337L8.11504 8.72237C8.53729 9.05687 9.13204 9.05687 9.55729 8.71937L12.8843 6.01487C13.1258 5.81762 13.4798 5.85512 13.6763 6.09662C13.872 6.33737 13.8353 6.69137 13.5945 6.88787L10.2615 9.59687C9.84004 9.93137 9.33604 10.0986 8.83279 10.0986Z"
          fill={color}
        />
        <mask
          id="mask0_797_11802"
          maskUnits="userSpaceOnUse"
          x="0"
          y="1"
          width="17"
          height="16"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.75 1.5H16.8749V16.125H0.75V1.5Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_797_11802)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.12925 15H12.4943C12.4958 14.9985 12.5017 15 12.5063 15C13.362 15 14.121 14.694 14.703 14.1128C15.3787 13.44 15.75 12.4732 15.75 11.391V6.24C15.75 4.14525 14.3805 2.625 12.4943 2.625H5.13075C3.2445 2.625 1.875 4.14525 1.875 6.24V11.391C1.875 12.4732 2.247 13.44 2.922 14.1128C3.504 14.694 4.26375 15 5.11875 15H5.12925ZM5.1165 16.125C3.95925 16.125 2.92575 15.705 2.12775 14.91C1.239 14.0235 0.75 12.774 0.75 11.391V6.24C0.75 3.53775 2.63325 1.5 5.13075 1.5H12.4943C14.9918 1.5 16.875 3.53775 16.875 6.24V11.391C16.875 12.774 16.386 14.0235 15.4972 14.91C14.7 15.7042 13.6658 16.125 12.5063 16.125H12.4943H5.13075H5.1165Z"
            fill={color}
          />
        </g>
      </svg>
    );
  }),
);
